export default [
    {
        componente : 'detalhes',
        titulo : 'DETALHES DO PROJETO',
        esconderTitulo : true,
        chavePermissao : "ProjetosGestaoDetalhes",
    },
    {
        componente : 'empresas',
        titulo : 'EMPRESAS', 
        esconderTitulo : false,
        chavePermissao : "ProjetosGestaoEmpresas",
    },
    {
        componente : 'rh',
        titulo : 'RH - RECURSOS HUMANOS',
        esconderTitulo : false,
        chavePermissao : "ProjetosGestaoRecursoHumano",
    },
    {
        componente : 'st',
        titulo : 'ST - SERVIÇOS DE TERCEIROS',
        esconderTitulo : false,
        chavePermissao : "ProjetosGestaoServicoTerceiro",
    },
{
        componente : 'mc',
        titulo : 'MC - MATERIAL DE CONSUMO',
        esconderTitulo : false,
        chavePermissao : "ProjetosGestaoMaterialConsumo",
    },
    {
        componente : 'vd',
        titulo : 'VD - VIAGENS E DIÁRIAS',
        esconderTitulo : false,
        chavePermissao : "ProjetosGestaoViagemDiarias",
    },
    {
        componente : 'ou',
        titulo : 'OU - OUTROS',
        esconderTitulo : false,
        chavePermissao : "ProjetosGestaoOutros",
    },
    {
        componente : 'ct',
        titulo : 'CT - CITENEL', 
        esconderTitulo : false,
        chavePermissao : "ProjetosGestaoCitenel",
    },
    {
        componente : 'auditoria',
        titulo : 'AC - AUDITORIA CONTÁBIL', 
        esconderTitulo : false,
        chavePermissao : "ProjetosGestaoAuditoria",
    },
    {
        componente : 'atividades',
        titulo : 'ATIVIDADES', 
        esconderTitulo : false,
        chavePermissao : "ProjetosGestaoAtividades",
    },
    {
        componente : 'cronograma_etapa',
        titulo : 'CRONOGRAMA DE ETAPAS', 
        esconderTitulo : false,
        chavePermissao : "ProjetosGestaoCronogramaEtapa",
    },
    {
        componente : 'investimentos',
        titulo : 'DISTRIBUIÇÃO POR RUBRICAS', 
        esconderTitulo : false,
        chavePermissao : "ProjetosGestaoInvestimento",
    },
    {
        componente : 'aneel',
        titulo : 'OBRIGAÇÕES NA ANEEL', 
        esconderTitulo : false,
        chavePermissao : "ProjetosGestaoObrigacoesAneel",
    },
    {
        componente : 'documentos',
        titulo : 'CONTRATO E DOCUMENTAÇÃO', 
        esconderTitulo : false,
        chavePermissao : "ProjetosGestaoContrato",
    },
   
    {
        componente : 'capacitacao-profissional',
        titulo : 'CP - CAPACITAÇÃO PROFISSIONAL', 
        esconderTitulo : false,
        chavePermissao : "ProjetosGestaoCapacitacaoProfissional",
    },
    {
        componente : 'producao-cientifica',
        titulo : 'PC - PRODUÇÃO CIENTÍFICA / CAPACITAÇÃO TECNOLÓGICA', 
        esconderTitulo : false,
        chavePermissao : "ProjetosGestaoProducaoCientifica",
    },
    
    
]